export const mobileCheck = () => {
    return window.matchMedia('(pointer: coarse)').matches;
};
